/**
 * Chế độ CHỈ XEM, bật bằng tham số `?readonly=1` trên URL trình xem.
 *
 * Dùng cho trang chia sẻ kết quả gửi bệnh nhân (RIS `/result/<token>` nhúng trình xem trong iframe):
 * người bệnh chỉ được xem ảnh, KHÔNG được đo đạc / chú thích / lưu bất cứ thứ gì xuống máy chủ.
 * Bác sĩ mở trình xem theo đường bình thường (không có tham số) nên không đổi gì.
 *
 * Chỉ che phần giao diện — không thay cho việc chặn ở máy chủ.
 */
export function laCheDoChiXem(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  return new URLSearchParams(window.location.search).get('readonly') === '1';
}

export default laCheDoChiXem;
